module.exports = __webpack_public_path__ + "img/pic_new_features_3.b349ca0d.png";